/**
 * « Ton masteur te parle · Voir la visio » (Wajih, 24/10). Au téléphone, un changement de mode ne déplace plus
 * l'élève de son onglet : renvoyé sur la visio au retour en Dialogue, il quittait l'exercice qu'il faisait (un
 * élève, en séance : « au lieu de me laisser sur l'activité, ça me met direct sur la visio »). Resté sur
 * l'activité, il entend son masteur ; la barre lui dit que la visio l'attend, et l'y mène d'un toucher.
 *
 *  - **Au téléphone, sur l'activité** : sur la visio, il voit son masteur ; au grand écran, la visio est à côté.
 *  - **Dans la file des barres du live**, au ton de l'information (le masteur arrive, une nouvelle activité) :
 *    ce n'est pas une alerte. La connexion perdue passe devant : l'élève n'entend plus son masteur.
 *  - **Elle se retire seule** au bout de `TUTOR_TALKING_NOTICE_MS`, dès qu'il est sur la visio, au repassage en
 *    Concentré, ou quand le masteur envoie Sam (l'écran).
 */
import { type UILiveView } from "../../molecules/LiveViewSwitch"

/**
 * Dix secondes. La barre n'apprend rien à l'élève, elle l'invite : il entend déjà son masteur (le son du
 * Dialogue, puis sa voix), et l'onglet « Visio » reste dans l'en-tête. Elle prend la place, au-dessus de
 * l'exercice qu'il a choisi de garder : posée tout le Dialogue (souvent tout le cours, en individuel), elle la
 * lui coûterait pour rien. Dix secondes laissent entendre la première phrase du masteur (« Tu m'entends ? »)
 * et décider, et c'est la plus longue durée qu'on donne à un message porteur d'une action (4 à 10 s) ; le
 * bandeau d'un accusé, ici, en tient 4. Elle part même sous un lecteur d'écran, à la différence d'un bandeau
 * porteur d'une action (`snackbarAutoHideMs`, WCAG 2.2.1) : son geste ne part pas avec elle, l'onglet « Visio »
 * le porte, et sa phrase est lue à son arrivée (une région vive). Le web ne sait d'ailleurs pas dire si un
 * lecteur d'écran est actif (react-native-web répond toujours oui) : la règle l'y laisserait tout le Dialogue.
 */
export const TUTOR_TALKING_NOTICE_MS = 10_000

/**
 * La barre a quelque chose à dire, et son délai court. La connexion perdue la cache sans arrêter le compte : une
 * coupure plus longue que lui ne la fait pas revenir, en retard, à la reprise.
 */
export function tutorTalkingNoticeDue(input: {
    /** Le masteur vient de repasser en Dialogue, l'élève sur l'activité (l'écran). */
    tutorTalking: boolean
    /** Deux volets, la visio à côté de l'activité. */
    wide: boolean
    view: UILiveView
}): boolean {
    const { tutorTalking, wide, view } = input
    return tutorTalking && !wide && view === "activity"
}
